import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants, Colors, Globals } from 'utils';
import PaperClip from './paperclip';
import { StorageService } from 'services';
import { ViewIcon, UploadIcon, DownloadIcon } from 'assets/icons';
import moment from 'moment';
import { WhiteImage } from 'assets/img';

const RevisionItem = (params: any) => {
  const item: any = params.item;
  const user = useSelector((state: RootState) => state.user);
  const is_client = user?.level_id == Constants.LEVELS.CLIENT;

  const getColor = (item: any) => {
    switch (item.status) {
      case Constants.REVISION_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.REVISION_STATUS.ACCEPTED:
        return Colors.green;
        break;

      case Constants.REVISION_STATUS.REJECTED:
        return Colors.danger;
        break;
    }
  };

  return (
    <div className='item'>
      <div className='row row-files'>
        <div className='col-md-6'>
          <p className='date'>{moment(item.created_at).format('DD/MM/YYYY')}</p>
        </div>
        <div className='col-md-6'>
          <p className='number'>ID {item.number}</p>
        </div>
        <div className='col-md-10'>
          {((user?.level_id == Constants.LEVELS.CLIENT && item.lawyer != null) ||
            (user?.level_id == Constants.LEVELS.LAWYER && item.user != null)) && (
            <div className='container-lawyer'>
              <img
                src={
                  user?.level_id == Constants.LEVELS.CLIENT
                    ? item.lawyer?.photo
                      ? Constants.BASE_STORAGE + item.lawyer?.photo
                      : WhiteImage
                    : item.user?.photo
                      ? Constants.BASE_STORAGE + item.user?.photo
                      : WhiteImage
                }
              />
              <div className='container-name'>
                <p className='bold'>
                  {user?.level_id == Constants.LEVELS.CLIENT ? 'Abogado' : 'Cliente'}
                </p>
                <p>
                  {user?.level_id == Constants.LEVELS.CLIENT
                    ? item.lawyer?.full_name
                    : item.user?.full_name}
                </p>
              </div>
            </div>
          )}
          {((user?.level_id == Constants.LEVELS.CLIENT && item.lawyer == null) ||
            (user?.level_id == Constants.LEVELS.LAWYER && item.user == null)) && (
            <div className='container-no-lawyer'>
              <p>
                No se ha asignado{' '}
                {user?.level_id == Constants.LEVELS.CLIENT ? 'abogado' : 'cliente'}
              </p>
            </div>
          )}
        </div>
        <div className='col-md-2 text-right'>
          <div className='container-status' style={{ backgroundColor: getColor(item) }}>
            <p>{item.status_text}</p>
          </div>
        </div>
        <div className='col-md-6'>
          <a
            href='#'
            onClick={async (e: any) => {
              e.preventDefault();
              if (!item.file) {
                if (is_client && params.openUpload) {
                  params.openUpload();
                }
                return;
              }
              const opened = await StorageService.openFile(item.file);
              if (!opened) Globals.showError('No se pudo obtener el archivo');
            }}
          >
            <div className={`file ${!is_client && item.file == null ? 'disabled' : ''}`}>
              <img src={!is_client ? DownloadIcon : item.file ? ViewIcon : UploadIcon} />
              <div style={{ flex: 1 }}>
                <p>
                  {!is_client
                    ? 'Descargar documento'
                    : item.file
                      ? 'Documento enviado'
                      : 'Enviar documento'}
                </p>
              </div>
            </div>
          </a>
        </div>
        <div className='col-md-6'>
          <PaperClip
            formats={['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'png', 'jpg', 'jpeg']}
            value={''}
            onClick={
              item.file_response != null ? () => StorageService.openFile(item.file_response) : null
            }
            disabled={is_client && item.file_response == null}
            onChange={(e: any) => {
              params.sendResponse(item, e.target.value);
            }}
          >
            <a>
              <div className={`file ${is_client && item.file_response == null ? 'disabled' : ''}`}>
                <img
                  src={!is_client ? (item.file_response == null ? UploadIcon : ViewIcon) : ViewIcon}
                />
                <div style={{ flex: 1 }}>
                  <p>
                    {!is_client
                      ? item.file_response
                        ? 'Documento enviado'
                        : 'Subir documento'
                      : 'Documento recibido'}
                  </p>
                </div>
              </div>
            </a>
          </PaperClip>
        </div>
        {/* DESHABILITADO: nuevo flujo de revision documental -- el cliente
            ya no aprueba/rechaza el archivo. Se conserva comentado (no se
            elimina) por si se requiere revertir. */}
        {/* {is_client &&
          item.status == Constants.REVISION_STATUS.PENDING &&
          item.file_response != null && (
            <>
              <div className="col-md-6 text-center">
                <button
                  className="btn btn-accept"
                  onClick={() =>
                    params.setApproved(item, Constants.REVISION_STATUS.ACCEPTED)
                  }
                >
                  Aceptar
                </button>
              </div>
              <div className="col-md-6 text-center">
                <button
                  className="btn btn-reject"
                  onClick={() =>
                    params.setApproved(item, Constants.REVISION_STATUS.REJECTED)
                  }
                >
                  Rechazar
                </button>
              </div>
            </>
          )} */}
      </div>
    </div>
  );
};

export default RevisionItem;
